module.exports = __webpack_public_path__ + "img/gift_10.41f411cb.webp";